/**
 * Persons fields fetched for the contact block on the service report
 * (ServiceReportInfoCard.vue -> ContactInformation.vue).
 *
 * Part of the persisted "directory" configuration (key: serviceContactColumns).
 * Selection only: ContactInformation.vue renders its own purpose-built layout
 * (name, mailto link, address, country, website), so this controls WHICH person
 * fields are available to it, not how they are laid out.
 *
 * Dotted paths relative to the service record, same convention as
 * contactInfoColumns / headInfoColumns.
 */
export const ServiceContactColumns = [
  "contactInformation.id",
  "contactInformation.title_before_name",
  "contactInformation.first_name",
  "contactInformation.last_name",
  "contactInformation.title_after_name",
  "contactInformation.role",
  "contactInformation.email",
  "contactInformation.phone",
  "contactInformation.address",
  "contactInformation.zip",
  "contactInformation.city",
  "contactInformation.country.name",
  "contactInformation.country.label",
];

export default ServiceContactColumns;
